<!-- 群控管理 控制系统 -->
<template>
<div class="container containerBox">
    <div class="container-title" style="margin-top:0;">控制方式</div>
    <div style="margin-left:150px;">
		
        <el-radio-group v-model="controlType" @change="handleChange">
            <el-radio :label="1">所有风盘</el-radio>
            <el-radio :label="2">所有风柜</el-radio>
            <el-radio :label="3">按组别控制</el-radio>
            <el-radio :label="4">按集控器控制</el-radio>
            <el-radio :label="5">按楼宇结构控制</el-radio>
        </el-radio-group>
    </div>
    <div class="container-title">控制参数</div>
    <div style="margin-left:90px;" class="group-form">
        <el-form :model="form" status-icon :rules="rules" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <el-form-item label="状态" prop="powerStatus">
                        <el-select v-model="form.powerStatus" clearable placeholder="请选择">
                           <el-option
                                 v-for="item in options1"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value">
                           </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="showfan" label="风速" prop="fanSpeed">
                        <el-select v-model="form.fanSpeed" clearable placeholder="请选择">
                            <el-option
                                  v-for="item in options2"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="模式" prop="workMode">
                        <el-select v-model="form.workMode" clearable placeholder="请选择">
                            <el-option
                                  v-for="item in options3"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <el-form-item label="温度设置" prop="roomTemperatureSp">
                        <el-input v-model="form.roomTemperatureSp" 
                            @blur="handleChangeInput('roomTemperatureSp')" 
                            clear 
                            placeholder="请输入温度"></el-input>&nbsp;&nbsp;°C
                    </el-form-item>
                    <el-form-item label="锁定" prop="keyBoardlock">
                        <el-select v-model="locks" multiple placeholder="请选择" @change="changelock">
                            <el-option
                                  v-for="item in options4"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
								  :disabled="item.disabled">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
    <template v-if="controlType === 3">
        <div class="container-title">控制组别</div>
        <div style="margin-left:150px;">
            <el-transfer
                :titles="['组别', '控制组别']"
                filterable
                :filter-method="filterMethod"
                filter-placeholder="请输入关键字"
                v-model="groupValue"
                :data="groupData">
            </el-transfer>
        </div>
    </template>
    <template v-if="controlType === 4">
        <div class="container-title">控制集控器</div>
        <div style="margin-left:150px;">
            <el-transfer
                :titles="['集控器', '控制集控器']"
                filterable
                :filter-method="filterMethod"
                filter-placeholder="请输入关键字"
                v-model="getawayValue"
                :data="getawayData">
            </el-transfer>
        </div>
    </template>
    <template v-if="controlType === 5">
        <div class="container-title">按楼宇结构控制</div>
        <div style="margin-left:150px;">
            <div style="width:400px;min-height:180px;">
                <cmp-build-select 
                :buildRoom="buildRoom"
                changeOnSelect
                @listenBuildResult="listenBuildResult"></cmp-build-select>
            </div>  
        </div>
    </template>
    <div style="margin-left:150px;margin-top:20px;margin-bottom:50px">
        <el-button type="primary" style="width:200px;" :disabled="!checkPermission('device_control')" @click="onclick">确认执行</el-button>
    </div>
</div>
</template>

<script>
import { CLUSTERMANA } from '@/api/configData.js'
import Service from '@/api/Service'
import checkPermission from '@/utils/permission'
import {$Alert} from '@/utils/utils'
import CmpBuildSelect from '@/components/CmpBuildSelect/CmpBuildSelect'

export default {
    name: "clustermana1",
    inject: ["reload"],
    data() {
        return {
            controlType: 1, //    控制方式
            //  控制参数设置
			showfan:true,
			form: {
					devtype:'',
					powerStatus: '',             //  开关机：1
					fanSpeed: '',            //  风速：0
					workMode: '',         //  模式：0
					roomTemperatureSp: '',        //  设置温度：0
					keyBoardlock: '',          //  按键锁：0
					is_house:false
			},
			locks:[],
			options1: [{
			          value: 'on',
			          label: '开机'
			        }, {
			          value: 'off',
			          label: '关机'
			        }],
			options2: [{
			          value: 'auto',
			          label: '自动'
			        }, {
			          value: 'high',
			          label: '高风'
			        }, {
			          value: 'medium',
			          label: '中风'
			        }, {
			          value: 'low',
			          label: '低风'
			        }],
			options3: [{
			          value: 'cool',
			          label: '制冷'
			        }, {
			          value: 'fan',
			          label: '通风'
			        }, {
			          value: 'heat',
			          label: '制热'
			        }, {
			          value: 'auto',
			          label: '自动'
			        }],
			options4: [{
			          value: 1,
			          label: '锁定开关机',
			        }, {
			          value: 2,
			          label: '锁定模式',
			        }, {
			          value: 4,
			          label: '锁定风速',
			        }, {
			          value: 8,
			          label: '锁定温度',
			        }, {
			          value: 0,
			          label: '解除锁定'
			        }, {
			          value: 15,
			          label: '锁定全部'
			        }],	
            // form: {
            //     power_on: '',             //  开关机：1
            //     speed: '',            //  风速：0
            //     mode: '',         //  模式：0
            //     temperature: '',        //  设置温度：0
            //     key_lock: '',          //  按键锁：0
            // }, 
            // 参数设置校验
            rules: {

            },
            // 组别穿梭框
            groupData: [],
            groupValue: [],
            filterMethod(query, item) {
                return item.label.indexOf(query) > -1;
            },
            // 集控器穿梭框
            getawayData: [],
            getawayValue: [],

            // 选择房间组件
            buildRoom: {},
            houseOID: "",
        };
    },
    created() {
        this.getGroup();
    },
    components: {
        CmpBuildSelect,
    },
    methods: {
		
        checkPermission,
		async changelock(val){
			for(var i = 0 ; i<val.length;i++){
				if(val[i] == 0){
					this.locks = [0]
				}
				if(val[i] == 15){
					this.locks = [15]
				}
			}
			this.form.keyBoardlock = null
			this.locks.map(v =>{
				this.form.keyBoardlock += v * 1
			})
		},
        //   选择控制方式
        handleChange(val) {
            if(val === 2){
				this.showfan = false
				this.options4[2].disabled = true
			}else{
				this.showfan = true
				this.options4[2].disabled = false
			}
            if(val === 3) {
                this.getGroup();
                return;
            }
            if(val === 4) {
                this.getGateway();
                return;
            }
        },
        // 温度输入框
        handleChangeInput(key, val) {
            let value = this.form[key];

            if(isNaN(value) || value<0 || value>50) {
                this.$message({
                    type: "warning",
                    message: "温度可设置范围0-50;"
                })
                this.form[key] = "";
            }
        },
        // 获取组别
        async getGroup() {
            if(this.groupData.length > 0) return;
            let data = await Service.getMeterGroupList();
            if(data) {
                data = data === 'success' ? [] : data;
                let arr = [];
                data.map(v=>{
                    arr.push({
                        key: v.oid,
                        label: v.groupname
                    })
                })
                this.groupData = arr;
            }
        },
        // 获取集控器
        async getGateway() {
            if(this.getawayData.length > 0) return;
            let data = await Service.getCollector();
            if(data){
                data = data === 'success' ? [] : data;
                
                let arr = [];
                data.map(v=>{
                    arr.push({
                        key: v.oid,
                        label: v.dev_name
                    })
                })
                this.getawayData = arr;
            }
        },
		//验证温度
		onclick(){
			let value = this.form.roomTemperatureSp;
			if(value != ""){
				if(isNaN(value) || value<10 || value>50) {
					this.$message({
						type: "warning",
						message: "温度可设置范围10-50;"
					})
					}else{
						$Alert(`是否确认执行 `).then((bool)=>{
							if(bool){
								this.onSubmit()
							}
							})
					}
					
			}else{
			$Alert(`是否确认执行 `).then((bool)=>{
				if(bool){
					this.onSubmit()
				}
				})
				}
		},
        //   确认执行
        onSubmit() {
			
            if(!checkPermission('device_control')) {
                this.$notify({
                    title: '警告',
                    message: '暂无操作权限',
                    type: 'warning'
                });
                return
            }
            if(this.controlType === 1 || this.controlType === 2) {
                // 控制风盘风柜
                this.ControlByTyp();
            }
            if(this.controlType === 3) {
                if(this.groupValue.length<=0) {
                    this.$notify({
                        title: '警告',
                        message: '请选择要控制的分组！',
                        type: 'warning'
                    });
                    return
                }
                // 控制分组
                this.ControlByGroup();
            }
            if(this.controlType === 4) {
                if(this.getawayValue.length<=0) {
                    this.$notify({
                        title: '警告',
                        message: '请选择要控制的集控器！',
                        type: 'warning'
                    });
                    return
                }
                // 控制分组
                this.ControlByCollectorID();
            }
            if(this.controlType === 5) {
                if(this.houseOID == "") {
                    this.$notify({
                        title: '警告',
                        message: '请选择要控制的楼宇！',
                        type: 'warning'
                    });
                    return
                }
                // 控制楼宇
                this.ControlByCollectorMidlist();
            }
        },
        // 风盘风柜控制
        async ControlByTyp() {
            let form = Object.assign({},this.form);
            form.devtype = this.controlType;
            // 控制全部
            let data = await Service.controlallbydevtype(form)
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.reload();
            }
        },
        // 分组控制
        async ControlByGroup() {
            let arr = this.groupValue.map(v=>{
                return {oid:v}
            })
            let form = Object.assign({},this.form);
           
            let params = Object.assign({}, form, {goupidlist: JSON.stringify(arr)})
            let data = await Service.controlallbygroup(params)
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.reload();
            }
        },
        // 集控器控制
        async ControlByCollectorID() {
            let arr = this.getawayValue.map(v=>{
                return {oid:v}
            })
            let form = Object.assign({},this.form);

            let params = Object.assign({}, form, {collectorlist: JSON.stringify(arr)})
            let data = await Service.controlallbycollectors(params)
            
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.reload();
            }
        },
        // 按楼宇结构控制
        async ControlByCollectorMidlist() {
            let arr = [{oid: this.houseOID + ""}];
            let form = Object.assign({},this.form);
            let params = Object.assign({}, form, {moduleidlist: JSON.stringify(arr)})
            let data = await Service.controlallbymids(params)
            
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.reload();
            }
        },
        // 最后一级房间确认信息
        listenBuildResult(data) {
			if(data.householdid === undefined) {
			    // 建筑
			    this.form.is_house = false
			}else{
			    // 房间
			    this.form.is_house = true
			}
            this.houseOID = data.oid;
        },
    }
};
</script>
<style lang='css' scoped>
</style>